<div class="department-page">
  <app-header-style-seven></app-header-style-seven>

  <div class="custom-container">
    <section class="dept-hero">
      <div class="hero-grid">
        <div class="hero-copy">
          <span class="hero-kicker">Engineering Department</span>
          <h1>{{ departmentName }}</h1>
          <p>
            Advancing future-ready computing professionals through strong academic
            foundations, modern laboratories, research culture, industry exposure,
            and continuous student development.
          </p>
        </div>

        <div class="hero-stats">
          <div class="stat-card">
            <span class="stat-label">Established</span>
            <strong>{{ establishedYear }}</strong>
          </div>

          <div class="stat-card">
            <span class="stat-label">Affiliation</span>
            <strong>Anna University</strong>
          </div>

          <div class="stat-card">
            <span class="stat-label">Programme</span>
            <strong>{{ programmeSummary }}</strong>
          </div>

          <div class="stat-card">
            <span class="stat-label">Contact</span>
            <strong>{{ contactEmail }}</strong>
          </div>
        </div>
      </div>
    </section>

    <section class="notice-bar" aria-label="Admission update">
      <div class="notice-label">Admissions Update</div>
      <div class="notice-track">
        <span>{{ admissionNotice }}</span>
      </div>
    </section>

    <section class="department-shell">
      <aside class="department-sidebar">
        <div class="sidebar-card">
          <span class="sidebar-kicker">Department Menu</span>
          <h2>{{ departmentName }}</h2>

          <div class="tab-list">
            <button
              *ngFor="let tab of tabs"
              type="button"
              class="tab-btn"
              [class.active]="selectedTab === tab.id"
              (click)="selectTab(tab.id)"
            >
              {{ tab.label }}
            </button>
          </div>
        </div>
      </aside>

      <main class="department-main">
        <section class="content-head-card">
          <span class="content-tag">Academic Profile</span>
          <h2>{{ activeTabLabel }}</h2>
          <p>
            Department of Computer Science &amp; Engineering, Fatima Michael
            College of Engineering &amp; Technology, Madurai.
          </p>
        </section>

        <ng-container [ngSwitch]="selectedTab">
          <!-- About -->
          <ng-container *ngSwitchCase="'tab1'">
            <section class="content-card">
              <div class="banner-image">
                <img
                  src="assets/img/page-title/page-title4.jpeg"
                  alt="Department of Computer Science and Engineering"
                />
              </div>

              <div class="section-copy">
                <h3>About the Department</h3>
                <p *ngFor="let paragraph of aboutParagraphs">
                  {{ paragraph }}
                </p>

                <ul class="feature-list">
                  <li *ngFor="let item of aboutHighlights">
                    {{ item }}
                  </li>
                </ul>
              </div>
            </section>

            <section class="fact-grid">
              <article class="fact-card" *ngFor="let fact of quickFacts">
                <span class="fact-title">{{ fact.title }}</span>
                <p>{{ fact.value }}</p>
              </article>
            </section>
          </ng-container>

          <!-- Vision & Mission -->
          <ng-container *ngSwitchCase="'tab2'">
            <section class="info-grid">
              <article class="info-card emphasis-card">
                <div class="card-icon">
                  <img src="assets/img/vision-icon.png" alt="Vision" />
                </div>
                <h3>Our Vision</h3>
                <p>{{ visionText }}</p>
              </article>

              <article class="info-card emphasis-card">
                <div class="card-icon">
                  <img src="assets/img/mission-icon.png" alt="Mission" />
                </div>
                <h3>Our Mission</h3>
                <div class="stack-list">
                  <p *ngFor="let item of missionPoints">
                    {{ item }}
                  </p>
                </div>
              </article>
            </section>
          </ng-container>

          <!-- PEO -->
          <ng-container *ngSwitchCase="'tab3'">
            <section class="content-card">
              <div class="section-head">
                <h3>Program Educational Objectives (PEO)</h3>
                <p>
                  Broad academic, professional, and career outcomes expected from
                  graduates of the programme.
                </p>
              </div>

              <div class="numbered-list">
                <article class="number-card" *ngFor="let peo of peos; let i = index">
                  <div class="number-badge">{{ i + 1 }}</div>
                  <p>{{ peo }}</p>
                </article>
              </div>
            </section>
          </ng-container>

          <!-- POs & PSOs -->
          <ng-container *ngSwitchCase="'tab4'">
            <section class="content-card">
              <div class="section-head">
                <h3>Program Outcomes (POs)</h3>
                <p>
                  Knowledge, skills, ethics, and professional capabilities expected
                  from graduates.
                </p>
              </div>

              <div class="outcome-grid">
                <article class="outcome-card" *ngFor="let item of programOutcomes">
                  <h4>{{ item.title }}</h4>
                  <p>{{ item.description }}</p>
                </article>
              </div>
            </section>

            <section class="content-card">
              <div class="section-head">
                <h3>Program Specific Outcomes (PSOs)</h3>
                <p>
                  Department-specific competencies developed through Computer Science
                  and Engineering education.
                </p>
              </div>

              <div class="outcome-grid">
                <article class="outcome-card" *ngFor="let item of programSpecificOutcomes">
                  <h4>{{ item.title }}</h4>
                  <p>{{ item.description }}</p>
                </article>
              </div>
            </section>
          </ng-container>

          <!-- Programme Offered -->
          <ng-container *ngSwitchCase="'tab14'">
            <section class="content-card">
              <div class="section-head">
                <h3>Programmes Offered</h3>
                <p>Current academic programme details under the department.</p>
              </div>

              <div class="table-wrap">
                <table class="info-table">
                  <thead>
                    <tr>
                      <th>S.No</th>
                      <th>Programme Name</th>
                      <th>Duration</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let programme of programmes">
                      <td>{{ programme.sno }}</td>
                      <td>{{ programme.name }}</td>
                      <td>{{ programme.duration }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </section>
          </ng-container>

          <!-- Labs -->
          <ng-container *ngSwitchCase="'tab5'">
            <section class="content-card">
              <div class="section-head">
                <h3>Laboratory Facilities</h3>
                <p>
                  Practice-oriented computing laboratories that support core,
                  advanced, and emerging areas of Computer Science and Engineering.
                </p>
              </div>

              <div class="lab-grid">
                <article class="lab-card" *ngFor="let lab of labs">
                  <div class="lab-media">
                    <img [src]="lab.image" [alt]="lab.title" />
                  </div>

                  <div class="lab-body">
                    <h4>{{ lab.title }}</h4>
                    <p>{{ lab.description }}</p>
                  </div>
                </article>
              </div>
            </section>
          </ng-container>

          <!-- Association & Club Activities -->
          <ng-container *ngSwitchCase="'tab6'">
            <section class="content-card">
              <div class="section-head">
                <h3>Association &amp; Club Activities</h3>
                <p>
                  Major student association events, seminars, guest lectures, and
                  technical programmes organized by the department.
                </p>
              </div>

              <div class="table-wrap">
                <table class="info-table">
                  <thead>
                    <tr>
                      <th>S.No</th>
                      <th>Activity</th>
                      <th>Date</th>
                      <th>Description</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let activity of associationActivities">
                      <td>{{ activity.sno }}</td>
                      <td>{{ activity.activity }}</td>
                      <td>{{ activity.date }}</td>
                      <td>{{ activity.description }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </section>
          </ng-container>

          <!-- MoUs -->
   <!-- MoUs -->
<ng-container *ngSwitchCase="'tab7'">
  <section class="content-card">
    <div class="section-head">
      <h3>MoU's</h3>
      <p>
        Institutional collaborations supporting internships, projects,
        placements, research, and student innovation.
      </p>
    </div>

    <div class="table-wrap">
      <table class="info-table">
        <thead>
          <tr>
            <th>S.No</th>
            <th>Organization</th>
            <th>Date of Signing</th>
            <th>Purpose</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of mous">
            <td>{{ item.sno }}</td>
            <td>{{ item.organization }}</td>
            <td>{{ item.date }}</td>
            <td>{{ item.purpose }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="section-head" *ngIf="mouPhotos.length > 0">
      <h3>MoU Photo Gallery</h3>
      
    </div>

    <div class="lab-grid" *ngIf="mouPhotos.length > 0">
      <article class="lab-card" *ngFor="let photo of mouPhotos">
        <div class="lab-media">
          <img [src]="photo.image" [alt]="photo.alt" />
        </div>
        <div class="lab-body">
          <p>{{ photo.note }}</p>
        </div>
      </article>
    </div>
  </section>
</ng-container>

          <!-- Placement Record -->
          <ng-container *ngSwitchCase="'tab8'">
            <section class="content-card">
              <div class="section-head">
                <h3>Placement Record</h3>
                <p>
                  Placement details of students from the Department of Computer Science &amp; Engineering.
                </p>
              </div>

              <ng-container *ngIf="placementRecords.length > 0; else noPlacementData">
                <div class="stack-section" *ngFor="let yearGroup of placementRecords">
                  <div class="section-head">
                    <h3>Academic Year: {{ yearGroup.academicYear }}</h3>
                  </div>

                  <div class="table-wrap">
                    <table class="info-table">
                      <thead>
                        <tr>
                          <th>S.No</th>
                          <th>Name of the Student</th>
                          <th>Designation</th>
                          <th>Name of the Company</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let student of yearGroup.records">
                          <td>{{ student.sno }}</td>
                          <td>{{ student.studentName }}</td>
                          <td>{{ student.designation }}</td>
                          <td>{{ student.companyName }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </ng-container>

              <ng-template #noPlacementData>
                <div class="section-copy">
                  <p>Placement record details will be updated soon.</p>
                </div>
              </ng-template>
            </section>
          </ng-container>

      <!-- Industrial Visit -->
<ng-container *ngSwitchCase="'tab9'">
  <section class="content-card">
    <div class="section-head">
      <h3>Industrial Visit</h3>
      <p>
        Industrial visits organized for the students of the Department of
        Computer Science &amp; Engineering.
      </p>
    </div>

    <ng-container *ngIf="industrialVisits.length > 0; else noIndustrialVisitData">
      <div class="table-wrap">
        <table class="info-table">
          <thead>
            <tr>
              <th>S.No</th>
              <th>Date</th>
              <th>Industry</th>
              <th>No. of Students Benefitted</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of industrialVisits">
              <td>{{ item.sno }}</td>
              <td>{{ item.date }}</td>
              <td>{{ item.industry }}</td>
              <td>{{ item.studentsBenefitted }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="section-head">
        <h3>Industrial Visit Gallery</h3>
        
      </div>

      <div class="lab-grid">
        <article class="lab-card" *ngFor="let item of industrialVisits">
          <div class="lab-media">
            <img [src]="item.image" [alt]="item.alt" />
          </div>
          <div class="lab-body">
            <p>
              <strong>{{ item.date }}</strong> - {{ item.industry }} -
              {{ item.studentsBenefitted }} Students Benefitted
            </p>
          </div>
        </article>
      </div>
    </ng-container>

    <ng-template #noIndustrialVisitData>
      <div class="section-copy">
        <p>Industrial visit details will be updated soon.</p>
      </div>
    </ng-template>
  </section>
</ng-container>

          <!-- Value Added Courses -->
          <ng-container *ngSwitchCase="'tab10'">
            <section class="content-card">
              <div class="section-head">
                <h3>Value Added Courses</h3>
                <p>
                  Additional skill-oriented courses conducted for the students of the
                  Department of Computer Science &amp; Engineering.
                </p>
              </div>

              <ng-container *ngIf="valueAddedCourses.length > 0; else noValueAddedCourseData">
                <div class="table-wrap">
                  <table class="info-table">
                    <thead>
                      <tr>
                        <th>S.No</th>
                        <th>Course Name</th>
                        <th>Description</th>
                        <th>Duration</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let course of valueAddedCourses">
                        <td>{{ course.sno }}</td>
                        <td>{{ course.courseName }}</td>
                        <td>{{ course.description }}</td>
                        <td>{{ course.duration }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <div class="lab-grid" *ngIf="valueAddedCoursePhotos.length > 0">
                  <article class="lab-card" *ngFor="let photo of valueAddedCoursePhotos">
                    <div class="lab-media">
                      <img [src]="photo.image" [alt]="photo.alt" />
                    </div>
                  </article>
                </div>
              </ng-container>

              <ng-template #noValueAddedCourseData>
                <div class="section-copy">
                  <p>Value added course details will be updated soon.</p>
                </div>
              </ng-template>
            </section>
          </ng-container>

          <!-- Alumni -->
<!-- Alumni -->
<ng-container *ngSwitchCase="'tab11'">
  <section class="content-card">
    <div class="section-head">
      <h3>Distinguished Alumni Profiles</h3>
      <p>
        Distinguished alumni of the Department of Electronics &amp; Communication
        Engineering who are serving in reputed organizations across diverse domains.
      </p>
    </div>

    <ng-container *ngIf="distinguishedAlumniProfiles.length > 0; else noAlumniData">
      <div class="alumni-grid">
        <article
          class="alumni-card"
          *ngFor="let alumni of distinguishedAlumniProfiles"
        >
          <div class="alumni-image-wrap">
            <img
              [src]="alumni.image"
              [alt]="alumni.alt"
              class="alumni-image"
            />
          </div>

          <div class="alumni-body">
            <h4>{{ alumni.name }}</h4>
            <p><strong>Batch:</strong> {{ alumni.batch }}</p>
            <p><strong>Working Address:</strong> {{ alumni.workingAddress }}</p>
            <p><strong>Position:</strong> {{ alumni.position }}</p>
          </div>
        </article>
      </div>
    </ng-container>

    <ng-template #noAlumniData>
      <div class="section-copy">
        <p>Alumni details will be updated soon.</p>
      </div>
    </ng-template>
  </section>
</ng-container>

          <!-- Achievements -->
      <ng-container *ngSwitchCase="'tab12'">
  <section class="content-card">
    <div class="section-head">
      <h3>Achievements</h3>
      <p>
        Student achievements of the Department of Computer Science &amp; Engineering.
      </p>
    </div>

    <ng-container *ngIf="achievements.length > 0; else noAchievementData">
      <div class="table-wrap">
        <table class="info-table">
          <thead>
            <tr>
              <th>S.No</th>
              <th>Name of the Student</th>
              <th>Name of the Event</th>
              <th>Name of the College with Address</th>
              <th>State / National / International Level</th>
              <th>Date of Event</th>
              <th>Name of the Award</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of achievements">
              <td>{{ item.sno }}</td>
              <td>
                <div *ngFor="let student of item.studentNames">
                  {{ student }}
                </div>
              </td>
              <td>{{ item.eventName }}</td>
              <td>{{ item.collegeName }}</td>
              <td>{{ item.level }}</td>
              <td>{{ item.eventDate }}</td>
              <td>{{ item.awardName }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </ng-container>

    <ng-template #noAchievementData>
      <div class="section-copy">
        <p>Achievement details will be updated soon.</p>
      </div>
    </ng-template>
  </section>

  <section class="content-card">
    <div class="section-head">
      <h3>University Rank Holders</h3>
      <p>
        University rank holders of M.E. Computer Science &amp; Engineering with photo details.
      </p>
    </div>

    <ng-container *ngIf="universityRankHolders.length > 0; else noRankHolderData">
      <div class="table-wrap">
        <table class="info-table rank-holder-table">
          <thead>
            <tr>
              <th>S.No</th>
              <th>Batch</th>
              <th>Name</th>
              <th>Rank</th>
              <th>Photo</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of universityRankHolders; let i = index">
              <td>{{ i + 1 }}</td>
              <td>{{ item.batch }}</td>
              <td>{{ item.name }}</td>
              <td>{{ item.rank }}</td>
              <td>
                <div class="rank-photo-wrap">
                  <img [src]="item.photo" [alt]="item.alt" class="rank-photo" />
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </ng-container>

    <ng-template #noRankHolderData>
      <div class="section-copy">
        <p>University rank holder details will be updated soon.</p>
      </div>
    </ng-template>
  </section>
</ng-container>

          <!-- NPTEL -->
          <ng-container *ngSwitchCase="'tab13'">
            <section class="content-card">
              <div class="section-head">
                <h3>NPTEL</h3>
                <p>
                  NPTEL course certifications completed by faculty members of the Department of Computer Science &amp; Engineering.
                </p>
              </div>

              <div class="table-wrap">
                <table class="info-table">
                  <thead>
                    <tr>
                      <th>Sl. No.</th>
                      <th>Name of the Staff</th>
                      <th>Subject</th>
                      <th>Grade</th>
                      <th>Session</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let item of nptelRecords; let i = index">
                      <td>{{ i + 1 }}</td>
                      <td>{{ item.staffName }}</td>
                      <td>{{ item.subject }}</td>
                      <td>{{ item.grade }}</td>
                      <td>{{ item.session }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </section>
          </ng-container>

          <!-- Research -->
  <ng-container *ngSwitchCase="'tab15'">
  <section class="content-card">
    <div class="section-head">
      <h3>Journal Publication</h3>
      <p>
        Journal publications by faculty members of the Department of Computer Science &amp; Engineering.
      </p>
    </div>

    <ng-container *ngIf="journalPublications.length > 0; else noJournalData">
      <div class="table-wrap">
        <table class="info-table">
          <thead>
            <tr>
              <th>S.No</th>
              <th>Name of the Staff</th>
              <th>Title</th>
              <th>Journal Name</th>
              <th>Issue &amp; Volume No</th>
              <th>Month &amp; Year</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of journalPublications">
              <td>{{ item.sno }}</td>
              <td>
                <div *ngFor="let author of item.authors">
                  {{ author }}
                </div>
              </td>
              <td>{{ item.title }}</td>
              <td>{{ item.journalName }}</td>
              <td>{{ item.issueVolume }}</td>
              <td>{{ item.monthYear }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </ng-container>

    <ng-template #noJournalData>
      <div class="section-copy">
        <p>Journal publication details will be updated soon.</p>
      </div>
    </ng-template>
  </section>

  <section class="content-card">
    <div class="section-head">
      <h3>Conference</h3>
      <p>
        Conference publications and paper presentations by faculty members of the Department of Computer Science &amp; Engineering.
      </p>
    </div>

    <ng-container *ngIf="conferenceRecords.length > 0; else noConferenceData">
      <div class="table-wrap">
        <table class="info-table">
          <thead>
            <tr>
              <th>S.No</th>
              <th>Name of the Staff</th>
              <th>Title of the Paper</th>
              <th>Name of the Conference</th>
              <th>Venue</th>
              <th>Date</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of conferenceRecords">
              <td>{{ item.sno }}</td>
              <td>
                <div *ngFor="let author of item.authors">
                  {{ author }}
                </div>
              </td>
              <td>{{ item.paperTitle }}</td>
              <td>{{ item.conferenceName }}</td>
              <td>{{ item.collegeName }}</td>
              <td>{{ item.date }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </ng-container>

    <ng-template #noConferenceData>
      <div class="section-copy">
        <p>Conference details will be updated soon.</p>
      </div>
    </ng-template>
  </section>

  <section class="content-card">
    <div class="section-head">
      <h3>Fund Received</h3>
      <p>
        Project grants and funds received by faculty members of the Department of Computer Science &amp; Engineering.
      </p>
    </div>

    <ng-container *ngIf="fundReceivedRecords.length > 0; else noFundData">
      <div class="table-wrap">
        <table class="info-table">
          <thead>
            <tr>
              <th>S.No</th>
              <th>Name of the Staff</th>
              <th>Amount</th>
              <th>Funding Source</th>
              <th>Date</th>
              <th>Purpose</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of fundReceivedRecords">
              <td>{{ item.sno }}</td>
              <td>{{ item.staffName }}</td>
              <td>{{ item.amount }}</td>
              <td>{{ item.source }}</td>
              <td>{{ item.date }}</td>
              <td>{{ item.purpose }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </ng-container>

    <ng-template #noFundData>
      <div class="section-copy">
        <p>Fund received details will be updated soon.</p>
      </div>
    </ng-template>
  </section>

  <section class="content-card">
    <div class="section-head">
      <h3>Patent Publication</h3>
      <p>
        Patent and design publications recorded under the Department of Computer Science &amp; Engineering.
      </p>
    </div>

    <ng-container *ngIf="patentRecords.length > 0; else noPatentData">
      <div class="table-wrap">
        <table class="info-table">
          <thead>
            <tr>
              <th>S.No</th>
              <th>Academic Year</th>
              <th>Name</th>
              <th>Categories</th>
              <th>Title of the Invention</th>
              <th>Application Number</th>
              <th>Date of Publication</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of patentRecords">
              <td>{{ item.sno }}</td>
              <td>{{ item.academicYear }}</td>
              <td>{{ item.name }}</td>
              <td>{{ item.category }}</td>
              <td>{{ item.inventionTitle }}</td>
              <td>{{ item.applicationNumber }}</td>
              <td>{{ item.publicationDate }}</td>
              <td>{{ item.status }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </ng-container>

    <ng-template #noPatentData>
      <div class="section-copy">
        <p>Patent details will be updated soon.</p>
      </div>
    </ng-template>
  </section>
</ng-container>
        </ng-container>
      </main>
    </section>

    <section class="bottom-cta">
      <article class="cta-card contact-card">
        <span class="cta-kicker">Contact</span>
        <h3>Department Contact</h3>
        <p>
          Head of Department,<br />
          Department of Computer Science &amp; Engineering,<br />
          Fatima Michael College of Engineering &amp; Technology,<br />
          Madurai.
        </p>
        <a class="text-link" href="mailto:csehod@fmcet.ac.in">
          {{ contactEmail }}
        </a>
      </article>

      <article class="cta-card action-card">
        <span class="cta-kicker">Admissions</span>
        <h3>Welcome to Department of Computer Science &amp; Engineering</h3>
        <p>
          Become a Computer Science Engineer and build intelligent, scalable, and
          future-ready digital solutions.
        </p>
        <a routerLink="/inquiry" class="apply-button">
          Apply Now
        </a>
      </article>
    </section>
  </div>
</div>